export enum DictTenantType {
	Private = 1,
	Company,
}

export enum DictMeasurementUnit {
	m = 1,
	cm,
	mm,
}

export enum DictVolumeUnit {
	m3 = 1,
	m2,
}

export enum AppLanguage {
	English = 'en',
	Polish = 'pl',
	French = 'fr',
	Russian = 'ru',
	German = 'de',
	Spanish = 'es',
	Czech = 'cs',
	Greek = 'el',
}

export enum DictUserPanelDisplayPrice {
	Gross = 1,
	Net,
}

export enum PriceTypeLabel {
	Gross = 'Gross',
	Net = 'Net',
}

export enum DictUserPanelDefaultViewType {
	Map = 1,
	List = 2,
}

export enum DictUserPanelRentReservationConfig {
	None = 0,
	ReservationsEnabled = 1,
	RentsEnabled = 2,
	ReservationAndRentsEnabled = 3,
}

export enum DictContractIntegrationType {
	Off = 1,
	OnlyOtherContracts = 2,
	Full = 3,
}

export enum DictInsuranceIntegrationType {
	Optional = 1,
	Mandatory,
	MandatoryWithCustom,
	SprytkiAgent,
}

export enum WhatIsLink {
	Sprytki = 'https://coto.sprytki.pl/',
	Savvylockers = 'https://whatis.savvylockers.com/',
}

export enum DictRentTypes {
	Reservation = 'reservation',
	Rent = 'rent',
}

export enum DictPaymentMethodType {
	RecurringPayment = '1',
	OneTimePayment = '2',
	None = '100',
}

export enum DictPaymentRenewalType {
	SubscriptionPaymentRetry = '1',
	ChangeCreditCard = '2',
	OneTimePayment = '3',
}

export enum PaymentProvider {
	Fiserv = 0,
	Stripe,
	Comgate,
	FiservConnect,
	Autopay,
	None = 100,
}

export enum PrivateTenantCustomDataConfigType {
	IdCardOrPassport = 1,
	PassportNumberOrDriverLicenseNumber = 2,
	PersonalIdNumberOrPassportNumber,
	EsDNIOrEsNIEOrPassportNumber,
	DateOfBirthOnly,
	GrAFMAndDOYWithIdCardOrPassport,
	PeselOrPassport,
}

export enum OrderTransitionRequirementType {
	Payment = 1,
	AgreementOnlineSignatureByTenant,
	AgreementOnlineSignatureByAdmin,
}

export enum CommunicationType {
	None = 0,
	MiniPC = 1,
	GSM = 2,
	RegisterPlate = 4,
	Void = 8,
	NoKe = 16,
	Loxone = 32,
	NoCodeMiniPC = 64,
	MSpaceLock = 128,
	Mobipoint = 256,
	TTLock = 512,
}

export function hasFlag(value: number, flag: number): boolean {
	return (value & flag) === flag;
}

export enum UserRole {
	LocationAdmin = 'LocationAdmin',
	LocationChainAdmin = 'LocationChainAdmin',
	LocationKeeper = 'LocationKeeper',
	ProductOwnerAdmin = 'ProductOwnerAdmin',
	SuperAdmin = 'SuperAdmin',
	Tenant = 'Tenant',
	Guest = 'Guest',
	Accessor = 'Accessor',
}

export enum DictInsuranceType {
	CivilLiability = 1,
	Property = 2,
}
